import { getNumberedStepsTemplate } from "../../shortcodes/templates";
import { getShortcodeWrapper, addShortcodeToEditor } from "../../shortodeAddition";
import { parseToHtml } from "@/utility/parseToHtml";
import { NUMBERED_STEPS_EVENT_TYPES } from "@/constant";

const DATA_ATTR = "data-numbered-steps-data";

const encodeNumberedStepsData = data => window.btoa(escape(encodeURIComponent(JSON.stringify(data))));

const decodeNumberedStepsData = element => {
  if (!element) return {};

  return JSON.parse(decodeURIComponent(unescape(window.atob(element))));
};

const editNumberedStepsConfig = (editor, shortcodeWrapper) => {
  let currentData = decodeNumberedStepsData(shortcodeWrapper.getAttribute(DATA_ATTR));
  let isValid = null;

  const numberedStepsWindow = editor.windowManager.openUrl({
    title: "Numbered Steps",
    url: "/numbered-steps-dialog",
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "custom",
        name: "submit",
        text: "Submit",
        primary: true,
      },
    ],
    onAction: function (instance) {
      if (!isValid || !currentData) {
        numberedStepsWindow.sendMessage({
          type: NUMBERED_STEPS_EVENT_TYPES.NEED_VALIDATION,
          data: true,
        });

        return;
      }

      shortcodeWrapper.setAttribute(DATA_ATTR, encodeNumberedStepsData(currentData));
      editor.fire("change");
      instance.close();
    },
    onMessage: (instance, message) => {
      if (message.mceAction === NUMBERED_STEPS_EVENT_TYPES.REQUEST_DATA) {
        sendData();
      }

      if (message.mceAction === NUMBERED_STEPS_EVENT_TYPES.UPDATE_NUMBERED_STEPS_DATA && message.data) {
        currentData = message.data;
        isValid = true;
      }

      if (message.mceAction === NUMBERED_STEPS_EVENT_TYPES.VALIDATION) {
        isValid = message.data.isValid;
      }
    },
    width: 600,
    height: 700,
  });

  const sendData = () => {
    const existData = decodeNumberedStepsData(shortcodeWrapper.getAttribute(DATA_ATTR));
    numberedStepsWindow.sendMessage({
      type: NUMBERED_STEPS_EVENT_TYPES.SEND_DATA,
      data: existData,
    });
  };
};

const numberedStepsConfig = (tinymce, uuid, shortcodeOnClick) => {
  let currentData = null;
  let isValid = null;

  const numberedStepsWindow = tinymce.activeEditor.windowManager.openUrl({
    title: "Numbered Steps",
    url: "/numbered-steps-dialog",
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "custom",
        name: "submit",
        text: "Submit",
        primary: true,
      },
    ],
    onAction: function (instance) {
      if (!isValid || !currentData) {
        numberedStepsWindow.sendMessage({
          type: NUMBERED_STEPS_EVENT_TYPES.NEED_VALIDATION,
          data: true,
        });

        return;
      }

      const shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, getNumberedStepsTemplate(), "numbered-steps");

      const shortcodeWrapperEl = parseToHtml(shortcodeWrapper).querySelector(".shortcode");
      shortcodeWrapperEl.setAttribute(DATA_ATTR, encodeNumberedStepsData(currentData));
      addShortcodeToEditor(shortcodeWrapperEl.outerHTML, uuid);

      instance.close();
    },
    onMessage: (instance, message) => {
      if (message.mceAction === NUMBERED_STEPS_EVENT_TYPES.REQUEST_DATA) {
        numberedStepsWindow.sendMessage({
          type: NUMBERED_STEPS_EVENT_TYPES.SEND_DATA,
          data: "undefined",
        });
      }

      if (message.mceAction === NUMBERED_STEPS_EVENT_TYPES.UPDATE_NUMBERED_STEPS_DATA) {
        currentData = message.data;
        isValid = true;
      }

      if (message.mceAction === NUMBERED_STEPS_EVENT_TYPES.VALIDATION) {
        isValid = message.data.isValid;
      }
    },
    width: 600,
    height: 700,
  });
};

export { numberedStepsConfig, editNumberedStepsConfig };
